module.exports = __webpack_public_path__ + "static/media/html5.5080b233.svg";